/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

// Los nombres van cruzados como en el legacy: _flor y _clear_flor2 controlan
// "pixelsFLOR" (pin 5); _flor2 y _clear_flor controlan "pixels" (pin 6).

export const ARDUINOUNO_servo_move_flor = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  const pin = block.getFieldValue('NPIN') || '';

  generator.definitions_.include_servo = '#include <Servo.h>\nServo servo_1;\nServo servo_2;\n';
  generator.setups_.servo_move_ = 'servo_1.attach(2);\nservo_2.attach(3);';

  return `servo_${pin}.write(${angle});\n`;
};

const installNeopixelFlor = (generator) => {
  generator.definitions_.neopixel_flor = `
#include <Adafruit_NeoPixel.h>
#define PINFLOR 5
#define NUMPIXELSFLOR 6
Adafruit_NeoPixel pixelsFLOR(NUMPIXELSFLOR, PINFLOR, NEO_GRB + NEO_KHZ800);
`;
  generator.setups_.BHOOT_led_neopixel_flor = 'pixelsFLOR.begin();\n';
};

export const BHOOT_led_neopixel_flor = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  const brightness = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC) || 0;
  installNeopixelFlor(generator);
  generator.loop_.BHOOT_led_neopixel_flor = '';
  return `
pixelsFLOR.setBrightness(${brightness});
for(int i=0;i<NUMPIXELSFLOR;i++){
  pixelsFLOR.setPixelColor(i, pixelsFLOR.Color(${color}));
}
pixelsFLOR.show();
delayMicroseconds(300);
`;
};

export const BHOOT_led_neopixel_clear_flor2 = (block, generator) => {
  installNeopixelFlor(generator);
  generator.loop_.BHOOT_led_neopixel_clear_flor2 = '';
  return `
for(int i=0;i<NUMPIXELSFLOR;i++){
  pixelsFLOR.setPixelColor(i, pixelsFLOR.Color(0, 0, 0));
}
pixelsFLOR.show();
delayMicroseconds(300);
`;
};

const installNeopixelReflector = (generator) => {
  generator.definitions_.numpixl_6 = `
#include <Adafruit_NeoPixel.h>
#define PIN 6
#define NUMPIXELS 6

Adafruit_NeoPixel pixels(NUMPIXELS, PIN, NEO_GRB + NEO_KHZ800);
`;
  generator.setups_.numpixl_7 = 'pixels.begin();';
};

export const BHOOT_led_neopixel_flor2 = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  const led = block.getFieldValue('LED') || '0';
  const brightness = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC) || 0;
  installNeopixelReflector(generator);
  generator.loop_.numpixl_7 = '';
  return `
pixels.setBrightness(${brightness});
pixels.setPixelColor(${led},pixels.Color(${color}));
pixels.show();
delayMicroseconds(300);
`;
};

export const BHOOT_led_neopixel_clear_flor = (block, generator) => {
  const led = block.getFieldValue('LED') || '0';
  installNeopixelReflector(generator);
  generator.loop_.numpixl_7 = '';
  return `
pixels.setPixelColor(${led}, pixels.Color(0,0,0));
pixels.show();
delayMicroseconds(300);
`;
};
